module.exports = __webpack_public_path__ + "static/media/galerija_2023 (1).d27a90a2.jpg";